module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iEzg4"))).then(() => parcelRequire('f4eak'));